var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v(_vm._s(_setup.name))]
          ),
          _vm._v(" "),
          !_setup.isDeleted
            ? _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.invokeTriggerPipelineManuallyCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-bolt",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Run pipeline")]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.isDeleted
            ? _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handleAbortPipelineRunsCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-ban",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Abort runs")]),
                ]
              )
            : _c(
                "a",
                {
                  staticClass: "btn btn-link btn-sm",
                  attrs: { role: "button" },
                  on: { click: _setup.handlePermanentDeletePipelineCommandV1 },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-bolt",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Delete permanently")]),
                ]
              ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }, [
          _c("div", { staticClass: "dropdown" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-success dropdown-toggle",
                attrs: {
                  type: "button",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false",
                },
              },
              [_vm._v("\n                        Share\n                    ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-menu" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-item",
                  attrs: {
                    href: `/#/sharing/resource/PipelineTriggerDataShareResourceProvider/${_setup.id}`,
                  },
                },
                [_vm._v("Trigger")]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    !_setup.isDeleted
      ? _c("div", { staticClass: "container" }, [
          _c(
            "a",
            {
              attrs: {
                href: `/#/admin/integrations/pipelines/configure/connector/${_setup.tid}/${_setup.id}`,
              },
            },
            [_vm._v("Configure connector")]
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              "(" + _vm._s(_setup.connectorName || "Not configured") + ")"
            ),
          ]),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: `/#/admin/integrations/pipelines/configure/dataset/${_setup.tid}/${_setup.id}`,
              },
            },
            [_vm._v("Configure dataset")]
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v("("),
            _c(
              "a",
              {
                attrs: {
                  href: `/#/admin/integrations/datasets/details/${_setup.datasetId}`,
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_setup.datasetName || "Not configured"))]
            ),
            _vm._v(")"),
          ]),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: `/#/admin/integrations/pipelines/configure/properties/${_setup.tid}/${_setup.id}`,
              },
            },
            [_vm._v("Configure properties")]
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: `/#/admin/integrations/pipelines/configure/mapping/${_setup.tid}/${_setup.id}`,
              },
            },
            [_vm._v("Configure mappings")]
          ),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: `/#/admin/integrations/pipelines/configure/ids/${_setup.tid}/${_setup.id}`,
              },
            },
            [_vm._v("Configure IDs")]
          ),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary",
              attrs: {
                href: `/#/admin/integrations/pipelines/preview/${_setup.tid}/${_setup.id}`,
                role: "button",
              },
            },
            [_vm._v("Preview")]
          ),
          _vm._v(" "),
          _setup.connectorProviderReadPageUrl
            ? _c(
                "a",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    href: `${_setup.connectorProviderReadPageUrl}${_setup.tid}?pipelineId=${_setup.id}&connectorId=${_setup.connectorId}`,
                    role: "button",
                    target: "_blank",
                  },
                },
                [_vm._v("Open")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_setup.isActive
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  on: { click: _setup.invokeActivatePipelineCommandV1 },
                },
                [_vm._v("Activate")]
              )
            : _c(
                "button",
                {
                  staticClass: "btn btn-warning",
                  on: { click: _setup.invokeDeactivatePipelineCommandV1 },
                },
                [_vm._v("Deactivate")]
              ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-danger",
              attrs: { disabled: _setup.isActive },
              on: { click: _setup.handleDeletePipelineCommandV1 },
            },
            [_vm._v("Delete")]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          !_setup.connectorOnlyInternalTriggers
            ? _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "applyChangesMode" } }, [
                    _vm._v("Apply changes mode:"),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.applyChangesMode,
                          expression: "applyChangesMode",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "applyChangesMode",
                        id: "applyChangesModeAllAtOnce",
                      },
                      domProps: {
                        value: 1,
                        checked: _vm._q(_setup.applyChangesMode, 1),
                      },
                      on: {
                        change: function ($event) {
                          _setup.applyChangesMode = 1
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "applyChangesModeAllAtOnce" },
                      },
                      [_vm._v("All at once")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.applyChangesMode,
                          expression: "applyChangesMode",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "applyChangesMode",
                        id: "applyChangesModeOneByOne",
                      },
                      domProps: {
                        value: 2,
                        checked: _vm._q(_setup.applyChangesMode, 2),
                      },
                      on: {
                        change: function ($event) {
                          _setup.applyChangesMode = 2
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "applyChangesModeOneByOne" },
                      },
                      [_vm._v("One by one")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.applyChangesMode,
                          expression: "applyChangesMode",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "applyChangesMode",
                        id: "applyChangesModeGroupByItem",
                      },
                      domProps: {
                        value: 3,
                        checked: _vm._q(_setup.applyChangesMode, 3),
                      },
                      on: {
                        change: function ($event) {
                          _setup.applyChangesMode = 3
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "applyChangesModeGroupByItem" },
                      },
                      [_vm._v("Group by item")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-secondary",
                      on: {
                        click: _setup.invokeChangeApplyChangesModeCommandV1,
                      },
                    },
                    [_vm._v("Update")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "timeTriggerRecurrency" } }, [
                    _vm._v("Time trigger:"),
                  ]),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.timeTriggerRecurrency,
                          expression: "timeTriggerRecurrency",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "timeTriggerRecurrency",
                        id: "timeTriggerRecurrencyNone",
                      },
                      domProps: {
                        value: null,
                        checked: _vm._q(_setup.timeTriggerRecurrency, null),
                      },
                      on: {
                        change: function ($event) {
                          _setup.timeTriggerRecurrency = null
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "timeTriggerRecurrencyNone" },
                      },
                      [_vm._v("None")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.timeTriggerRecurrency,
                          expression: "timeTriggerRecurrency",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "timeTriggerRecurrency",
                        id: "timeTriggerRecurrency10m",
                        value: "00:15:00",
                      },
                      domProps: {
                        checked: _vm._q(
                          _setup.timeTriggerRecurrency,
                          "00:15:00"
                        ),
                      },
                      on: {
                        change: function ($event) {
                          _setup.timeTriggerRecurrency = "00:15:00"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "timeTriggerRecurrency10m" },
                      },
                      [_vm._v("Every 15 minutes")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.timeTriggerRecurrency,
                          expression: "timeTriggerRecurrency",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "timeTriggerRecurrency",
                        id: "timeTriggerRecurrency10m",
                        value: "00:30:00",
                      },
                      domProps: {
                        checked: _vm._q(
                          _setup.timeTriggerRecurrency,
                          "00:30:00"
                        ),
                      },
                      on: {
                        change: function ($event) {
                          _setup.timeTriggerRecurrency = "00:30:00"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "timeTriggerRecurrency10m" },
                      },
                      [_vm._v("Every 30 minutes")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.timeTriggerRecurrency,
                          expression: "timeTriggerRecurrency",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "timeTriggerRecurrency",
                        id: "timeTriggerRecurrency1h",
                        value: "01:00:00",
                      },
                      domProps: {
                        checked: _vm._q(
                          _setup.timeTriggerRecurrency,
                          "01:00:00"
                        ),
                      },
                      on: {
                        change: function ($event) {
                          _setup.timeTriggerRecurrency = "01:00:00"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "timeTriggerRecurrency1h" },
                      },
                      [_vm._v("Hourly")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.timeTriggerRecurrency,
                          expression: "timeTriggerRecurrency",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "timeTriggerRecurrency",
                        id: "timeTriggerRecurrency1d",
                        value: "1.00:00:00",
                      },
                      domProps: {
                        checked: _vm._q(
                          _setup.timeTriggerRecurrency,
                          "1.00:00:00"
                        ),
                      },
                      on: {
                        change: function ($event) {
                          _setup.timeTriggerRecurrency = "1.00:00:00"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "timeTriggerRecurrency1d" },
                      },
                      [_vm._v("Daily")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.timeTriggerRecurrency,
                          expression: "timeTriggerRecurrency",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "timeTriggerRecurrency",
                        id: "timeTriggerRecurrency7d",
                        value: "7.00:00:00",
                      },
                      domProps: {
                        checked: _vm._q(
                          _setup.timeTriggerRecurrency,
                          "7.00:00:00"
                        ),
                      },
                      on: {
                        change: function ($event) {
                          _setup.timeTriggerRecurrency = "7.00:00:00"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "timeTriggerRecurrency7d" },
                      },
                      [_vm._v("Weekly")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _setup.timeTriggerRecurrency,
                          expression: "timeTriggerRecurrency",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "timeTriggerRecurrency",
                        id: "timeTriggerRecurrency30d",
                        value: "30.00:00:00",
                      },
                      domProps: {
                        checked: _vm._q(
                          _setup.timeTriggerRecurrency,
                          "30.00:00:00"
                        ),
                      },
                      on: {
                        change: function ($event) {
                          _setup.timeTriggerRecurrency = "30.00:00:00"
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "timeTriggerRecurrency30d" },
                      },
                      [_vm._v("Every 30 days")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-secondary",
                      on: {
                        click:
                          _setup.invokeChangePipelineTimeTriggerRecurrencyCommandV1,
                      },
                    },
                    [_vm._v("Update")]
                  ),
                ]),
                _vm._v(" "),
                !_setup.connectorOnlyInternalTriggers
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "triggerOnRunCompleted" } }, [
                        _vm._v("Pipeline completed trigger:"),
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _setup.triggerOnRunCompleted,
                              expression: "triggerOnRunCompleted",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "triggerOnRunCompleted" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _setup.triggerOnRunCompleted = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("None"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_setup.otherPipelines, function (p) {
                            return _c(
                              "option",
                              {
                                key: p.PipelineId,
                                domProps: { value: p.PipelineId },
                              },
                              [_vm._v(_vm._s(p.Name))]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-secondary",
                          on: {
                            click:
                              _setup.invokeChangePipelineTriggerOnRunCompletedCommandV1,
                          },
                        },
                        [_vm._v("Update")]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _setup.connectorInternalTriggers.length > 0
                  ? _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        { attrs: { for: "internalConnectorTrigger" } },
                        [_vm._v("Pipeline connector trigger:")]
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _setup.internalConnectorTrigger,
                              expression: "internalConnectorTrigger",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "internalConnectorTrigger" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _setup.internalConnectorTrigger = $event.target
                                .multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c("option", { domProps: { value: null } }, [
                            _vm._v("None"),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _setup.connectorInternalTriggers,
                            function (t) {
                              return _c(
                                "option",
                                { key: t.Name, domProps: { value: t.Name } },
                                [_vm._v(_vm._s(t.Title))]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm btn-secondary",
                          on: {
                            click:
                              _setup.invokeChangePipelineInternalConnectorTriggerCommandV1,
                          },
                        },
                        [_vm._v("Update")]
                      ),
                      _vm._v(" "),
                      _setup.selectedConnectorInternalTrigger?.PageUrl
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: `${_setup.selectedConnectorInternalTrigger?.PageUrl}/?pipelineId=${_setup.id}&connectorId=${_setup.connectorId}`,
                                target: "_blank",
                              },
                            },
                            [_vm._v("Open")]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ])
            : _c("div", { staticClass: "container" }, [
                _c("h4", [_vm._v("Pipeline was deleted")]),
              ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }